export function langSwitchByHrefLang(wrapper = document) {
    for (const langSwitchLink of wrapper.querySelectorAll(".js-switchLangByHrefLang")) {
        langSwitchLink.addEventListener("click", function (e) {
            const code = this.dataset.code;
            if (!code) return;

            const hrefLangLink = document.querySelector(`head link[hreflang^="${code.substring(0, 2)}"]`);
            if (hrefLangLink) {
                console.info("switch to href lang link", hrefLangLink);
                e.preventDefault();
                window.location.href = hrefLangLink.href;
            }
        });
    }
}